{
  "dateFormat": {
    "date": "DD/MM/YYYY",
    "time": "HH:mm",
    "dateTime": "DD/MM/YYYY HH:mm"
  },
  "common": {
    "error": "Digwyddodd gwall",
    "language": "Iaith",
    "theme": {
      "auto": "Dilyn y System",
      "light": "Modd Golau",
      "dark": "Modd Tywyll",
      "autoFollowSystem": "Dilyn Thema'r System"
    },
    "error_boundary_title": "Aeth rhywbeth o'i le",
    "error_boundary_subtitle": "Daeth y cais ar draws gwall annisgwyl. Ceisiwch ail-lwytho'r dudalen.",
    "reload": "Ail-lwytho'r Dudalen",
    "error_detail": "Manylion Gwall:",
    "save": {
      "failed": "Methu cadw"
    },
    "action": {
      "terminate": "Terfynu",
      "cancel": "Canslo",
      "ok": "Iawn",
      "submit": "Cyflwyno",
      "edit": "Golygu",
      "add": "Ychwanegu",
      "search": "Chwilio"
    },
    "form": {
      "association": "Cymdeithas",
      "alarmTest": "Prawf Larwm"
    },
    "na": "Amherthnasol",
    "loading": "Yn llwytho...",
    "backHome": "Yn ôl Adref",
    "gender": {
      "male": "Gwryw",
      "female": "Benyw",
      "other": "Arall"
    },
    "status": {
      "active": "Egnïol",
      "inactive": "Anweithgar",
      "pending": "Yn aros",
      "completed": "Wedi'i gwblhau"
    },
    "yearsOld": "{{age}} oed",
    "manualUpdate": "Diweddariad â Llaw"
  },
  "reload": {
    "timeout": {
      "title": "Terfyn Amser Cychwyn",
      "content": "Mae cychwyn y system yn cymryd gormod o amser. Argymhellir adnewyddu'r dudalen a rhoi cynnig arall arni.",
      "okText": "Adnewyddu",
      "cancelText": "Allgofnodi"
    }
  },
  "note": {
    "template": {
      "placeholder": "Dewiswch dempled"
    }
  },
  "exception": {
    "404": {
      "subTitle": "Mae'n ddrwg gennym, nid yw'r dudalen y gwnaethoch ymweld â hi yn bodoli."
    },
    "500": {
      "subTitle": "Mae'n ddrwg gennym, aeth rhywbeth o'i le."
    }
  },
  "auth": {
    "login": {
      "title": "Mewngofnodi",
      "subtitle": "Croeso yn ôl",
      "submit": "Mewngofnodi",
      "success": "Mewngofnodi yn llwyddiannus",
      "error": "Mewngofnodi wedi methu"
    },
    "validation": {
      "account": {
        "required": "Rhowch gyfrif!",
        "maxLength": "Ni all hyd y cyfrif fod yn fwy na 255 o nodau"
      },
      "password": {
        "required": "Rhowch gyfrinair!",
        "maxLength": "Ni all hyd y cyfrinair fod yn fwy na 128 o nodau",
        "minLengthDynamic": "Rhaid i'r cyfrinair fod o leiaf {{length}} nod!"
      },
      "email": {
        "required": "Rhowch gyfeiriad e-bost!",
        "invalid": "Rhowch gyfeiriad e-bost dilys!"
      },
      "field": {
        "required": "Rhowch {{field}}!"
      },
      "verificationCode": {
        "required": "Rhowch god dilysu!"
      },
      "confirmPassword": {
        "required": "Cadarnhewch y cyfrinair!"
      },
      "confirmNewPassword": {
        "required": "Cadarnhewch y cyfrinair newydd!"
      },
      "passwordMismatch": "Nid yw'r cyfrineiriau'n cyfateb!"
    },
    "register": {
      "title": "Cofrestru",
      "subtitle": "Creu cyfrif newydd",
      "submit": "Cofrestru"
    },
    "resetPassword": {
      "title": "Ailosod Cyfrinair",
      "subtitle": "Adfer eich cyfrif",
      "submit": "Ailosod Cyfrinair",
      "email": "E-bost",
      "verificationCode": "Cod Dilysu",
      "newPassword": "Cyfrinair Newydd",
      "confirmPassword": "Cadarnhewch y Cyfrinair Newydd",
      "sendCode": "Anfon Cod",
      "resendCode": "Aianfon",
      "resetButton": "Ailosod Cyfrinair",
      "backToSignIn": "Yn ôl i Mewngofnodi",
      "emailPlaceholder": "Rhowch gyfeiriad e-bost",
      "verificationCodePlaceholder": "Rhowch god dilysu",
      "newPasswordPlaceholder": "Rhowch gyfrinair newydd",
      "confirmPasswordPlaceholder": "Rhowch gyfrinair newydd eto",
      "emailRequired": "Rhowch gyfeiriad e-bost!",
      "emailInvalid": "Rhowch gyfeiriad e-bost dilys!",
      "verificationCodeRequired": "Rhowch god dilysu!",
      "newPasswordRequired": "Rhowch gyfrinair newydd!",
      "passwordMinLength": "Rhaid i'r cyfrinair fod o leiaf 6 nod!",
      "confirmPasswordRequired": "Cadarnhewch y cyfrinair newydd!",
      "passwordMismatch": "Nid yw'r cyfrineiriau'n cyfateb!",
      "codeSent": "Cod dilysu wedi'i anfon",
      "sendCodeFailed": "Wedi methu anfon cod dilysu",
      "resetSuccess": "Cyfrinair wedi'i ailosod yn llwyddiannus",
      "resetFailed": "Ailosod cyfrinair wedi methu",
      "countdown": "Aianfon ymhen {{seconds}}e"
    },
    "form": {
      "account": {
        "placeholder": "Rhowch gyfrif"
      },
      "password": {
        "placeholder": "Rhowch gyfrinair"
      },
      "email": {
        "placeholder": "Rhowch gyfeiriad e-bost"
      },
      "newPassword": {
        "placeholder": "Rhowch gyfrinair newydd"
      },
      "confirmPassword": {
        "placeholder": "Rhowch gyfrinair eto"
      },
      "confirmNewPassword": {
        "placeholder": "Rhowch gyfrinair newydd eto"
      },
      "verificationCode": {
        "placeholder": "Rhowch god dilysu"
      }
    },
    "verification": {
      "getCode": "Cael Cod",
      "resendIn": "Aianfon ymhen {{seconds}}e"
    },
    "message": {
      "registerSuccess": "Cofrestru yn llwyddiannus",
      "registerFailed": "Cofrestru wedi methu: ",
      "resetSuccess": "Cyfrinair wedi'i ailosod yn llwyddiannus",
      "resetFailed": "Ailosod cyfrinair wedi methu: "
    },
    "links": {
      "forgotPassword": "Wedi anghofio cyfrinair?",
      "forgotPasswordShort": "Wedi anghofio cyfrinair",
      "signUp": "Cofrestrwch nawr",
      "signIn": "Oes gennych chi gyfrif eisoes? Mewngofnodwch nawr",
      "backToSignIn": "Yn ôl i Mewngofnodi"
    },
    "signIn": {
      "title": "Mewngofnodi",
      "subtitle": "Croeso yn ôl",
      "username": "Enw defnyddiwr",
      "password": "Cyfrinair",
      "rememberMe": "Cofiwch fi",
      "forgotPassword": "Wedi anghofio cyfrinair?",
      "signInButton": "Mewngofnodi",
      "noAccount": "Dim cyfrif?",
      "signUpLink": "Cofrestrwch nawr",
      "usernamePlaceholder": "Rhowch enw defnyddiwr",
      "passwordPlaceholder": "Rhowch gyfrinair",
      "usernameRequired": "Rhowch enw defnyddiwr!",
      "passwordRequired": "Rhowch gyfrinair!"
    },
    "signUp": {
      "title": "Cofrestru",
      "subtitle": "Creu cyfrif newydd",
      "username": "Enw defnyddiwr",
      "email": "E-bost",
      "password": "Cyfrinair",
      "confirmPassword": "Cadarnhewch y Cyfrinair",
      "verificationCode": "Cod Dilysu",
      "sendCode": "Anfon Cod",
      "resendCode": "Aianfon",
      "signUpButton": "Cofrestru",
      "hasAccount": "Oes gennych chi gyfrif eisoes?",
      "signInLink": "Mewngofnodwch nawr",
      "usernamePlaceholder": "Rhowch enw defnyddiwr",
      "emailPlaceholder": "Rhowch gyfeiriad e-bost",
      "passwordPlaceholder": "Rhowch gyfrinair",
      "confirmPasswordPlaceholder": "Rhowch gyfrinair eto",
      "verificationCodePlaceholder": "Rhowch god dilysu",
      "usernameRequired": "Rhowch enw defnyddiwr!",
      "emailRequired": "Rhowch gyfeiriad e-bost!",
      "emailInvalid": "Rhowch gyfeiriad e-bost dilys!",
      "passwordRequired": "Rhowch gyfrinair!",
      "passwordMinLength": "Rhaid i'r cyfrinair fod o leiaf 6 nod!",
      "confirmPasswordRequired": "Cadarnhewch y cyfrinair!",
      "passwordMismatch": "Nid yw'r cyfrineiriau'n cyfateb!",
      "verificationCodeRequired": "Rhowch god dilysu!",
      "codeSent": "Cod dilysu wedi'i anfon",
      "sendCodeFailed": "Wedi methu anfon cod dilysu",
      "countdown": "Aianfon ymhen {{seconds}}e"
    }
  },
  "tempNote": {
    "title": {
      "edit": "Golygu Nodyn Dros Dro",
      "create": "Creu Nodyn Dros Dro"
    },
    "field": {
      "timeRange": "Ystod Amser",
      "reason": "Rheswm",
      "note": "Nodyn",
      "alarmType": "Math o Larwm"
    },
    "placeholder": {
      "startTime": "Amser cychwyn",
      "endTime": "Amser gorffen"
    },
    "validation": {
      "selectTimeRange": "Dewiswch ystod amser",
      "selectReason": "Dewiswch reswm",
      "inputNote": "Rhowch nodyn"
    }
  },
  "notificationCall": {
    "title": {
      "edit": "Golygu Galwad Hysbysu",
      "create": "Creu Galwad Hysbysu"
    },
    "field": {
      "selectPeriod": "Dewis Cyfnod"
    },
    "validation": {
      "selectPeriod": "Dewiswch y math o hysbysiad"
    }
  },
  "arc": {
    "profile": {
      "serviceUser": {
        "ServiceUserIntegration": {
          "viewInPannovation": "Gweld yn Pannovation"
        },
        "AssociatedServiceUser": {
          "birthday": "Pen-blwydd:",
          "age": "Oedran: {{age}}",
          "gender": "Rhyw:",
          "liveStyle": "Arddull Byw:",
          "independentLiving": "Byw'n Annibynnol",
          "groupLiving": "Byw mewn Grŵp",
          "phoneNumbers": "Rhifau ffôn",
          "device": "Dyfais",
          "address": "Cyfeiriad:",
          "scheme": "Cynllun:",
          "authority": "Awdurdod:",
          "locate": "Lleoli:",
          "lastUpdate": "Diweddariad Diwethaf {{time}} yn ôl"
        }
      },
      "schemeAuthority": {
        "AssociatedAuthority": {
          "phoneNumbers": "Rhifau ffôn",
          "administrator": "Gweinyddwr",
          "address": "Cyfeiriad:"
        },
        "AssociatedScheme": {
          "phoneNumbers": "Rhifau ffôn",
          "administrator": "Gweinyddwr",
          "authority": "Awdurdod",
          "address": "Cyfeiriad:"
        }
      },
      "devices": {
        "Devices": {
          "title": "Dyfeisiau",
          "columns": {
            "deviceName": "Enw'r Dyfais",
            "type": "Math",
            "guid": "GUID",
            "sn": "SN(Nifer cyfresol)",
            "address": "Cyfeiriad",
            "status": "Statws",
            "action": "Gweithred"
          },
          "type": {
            "connection": "Cysylltiad",
            "device": "Dyfais"
          },
          "action": {
            "ignore": "Anwybyddu",
            "restore": "Adfer"
          },
          "messages": {
            "failedToUpdate": "Methwyd â diweddaru"
          }
        }
      },
      "subscriptions": {
        "Subscription": {
          "title": "Tanysgrifiadau",
          "items": {
            "sub01": {
              "name": "Tanysgrifiad 01",
              "tier": "Aur",
              "note": "Cynnwys rhywfaint o wasanaeth. Disgrifiad o gynnwys y gwasanaeth, Disgrifiad o gynnwys y gwasanaeth",
              "validity": "Yn ddilys tan: 2025-12-31"
            },
            "sub02": {
              "name": "Tanysgrifiad 02",
              "tier": "Arian",
              "note": "Cynnwys rhywfaint o wasanaeth. Disgrifiad o gynnwys y gwasanaeth, Disgrifiad o gynnwys y gwasanaeth",
              "validity": "Yn ddilys tan: 2026-12-31"
            },
            "sub03": {
              "name": "Tanysgrifiad 03",
              "tier": "Aur",
              "note": "Disgrifiad o gynnwys y gwasanaeth, Disgrifiad o gynnwys y gwasanaeth"
            }
          }
        }
      },
      "contextPanel": {
        "ServiceUserInfo": {
          "additionalInfo": "Gwybodaeth Ychwanegol",
          "email": "E-bost:",
          "postCode": "Cod Post:",
          "contacts": "Cysylltiadau"
        },
        "TempNotes": {
          "createdDateTime": "Dyddiad ac Amser Crëwyd",
          "createdBy": "Crëwyd gan",
          "completedDateTime": "Dyddiad ac amser cwblhawyd",
          "completedBy": "Cwblhawyd gan",
          "status": "Statws",
          "note": "Nodyn"
        },
        "NotificationCalls": {
          "createdDateTime": "Dyddiad ac Amser Crëwyd",
          "createdBy": "Crëwyd gan",
          "completedDateTime": "Dyddiad ac amser cwblhawyd",
          "completedBy": "Cwblhawyd gan",
          "status": "Statws",
          "note": "Nodyn"
        },
        "Recommended": {
          "smartContext": "Cyd-destun Clyfar",
          "note": "Nodyn",
          "recentCalls": "Galwadau Diweddar"
        },
        "SchemeInfo": {
          "additionalInfo": "Gwybodaeth Ychwanegol",
          "name": "Enw:",
          "postCode": "Cod Post:",
          "contacts": "Cysylltiadau"
        },
        "AuthorityInfo": {
          "additionalInfo": "Gwybodaeth Ychwanegol",
          "name": "Enw:",
          "postCode": "Cod Post:",
          "contacts": "Cysylltiadau"
        },
        "CaseManagement": {
          "title": "Rheoli Achosion",
          "createdAt": "Crëwyd am",
          "selectDevices": "Dewiswch ddyfeisiau",
          "selectAssociationFirst": "Dewiswch gysylltiad yn gyntaf",
          "devicesNotSupportedForRefType": "Nid yw dyfeisiau ar gael ar gyfer y math cysylltiad hwn",
          "uploadMaxCountError": "Mwyaf o {{max}} ffeil wedi'u caniatáu",
          "validation": {
            "associateTo": "Dewiswch gysylltiad"
          }
        },
        "ContextPanel": {
          "tabs": {
            "recommended": "Argymhellir",
            "information": "Gwybodaeth",
            "sops": "SOPs",
            "notificationCall": "Galwad Hysbysu",
            "tempNote": "Nodyn dros dro",
            "audit": "Archwiliad",
            "caseManagement": "Rheoli Achosion",
            "schemes": "Cynlluniau",
            "serviceUsers": "Defnyddwyr Gwasanaeth"
          }
        },
        "AuthoritySchemeList": {
          "schemeName": "Enw'r Cynllun",
          "address": "Cyfeiriad",
          "status": "Statws",
          "userNote": "Nodyn Defnyddiwr",
          "search": "Chwilio"
        },
        "SchemeServiceUserList": {
          "name": "Enw",
          "gender": "Rhyw",
          "dateOfBirth": "Dyddiad Geni",
          "address": "Cyfeiriad",
          "status": "Statws",
          "userNote": "Nodyn Defnyddiwr",
          "search": "Chwilio"
        },
        "Sops": {
          "description": "Disgrifiad o {{chapterName}}"
        }
      }
    },
    "calling": {
      "WaitingControl": {
        "calling": "Yn galw...",
        "failedToAnswer": "Wedi methu ateb yr alwad",
        "failedToReject": "Wedi methu gwrthod yr alwad"
      },
      "DropdownControl": {
        "failedToMute": "Wedi methu tawelu/dad-dawelu",
        "unmute": "Dad-dawelu",
        "mute": "Tawelu",
        "record": "Cofnodi",
        "recording": "Yn cofnodi",
        "forward": "Blaenforio",
        "forwarded": "Wedi'i flaenforio",
        "forwardSuccess": "Llwyddiant blaenforio",
        "failedToForward": "Methwyd â blaenforio",
        "dial": "Deialu",
        "placeholder": {
          "phoneNumber": "Rhowch rif ffôn",
          "searchColleague": "Chwilio am gydweithiwr"
        }
      },
      "Status": {
        "iceRecovering": "ICE Yn adfer...",
        "ended": "Wedi dod i ben",
        "calling": "Yn galw",
        "forwarding": "Anfon ymlaen...",
        "holding": "Dal",
        "recording": "Recordio",
        "recordingPaused": "Mae'r recordiad wedi'i seibio.",
        "preparingTimeout": "Galwad allanol wedi dod i ben, ceisiwch eto"
      },
      "Control": {
        "failedToHangup": "Methu â chau'r alwad",
        "failedToHold": "Methu â dal/dad-ddal y galwad",
        "resume": "Ailddechrau",
        "speak": "Siarad",
        "busyHere": "Prysur yma",
        "rejected": "Gwrthodwyd",
        "timeout": "Amser wedi dod i ben"
      },
      "deviceControl": {
        "VolumeControl": {
          "speaker": "Siaradwr",
          "messages": {
            "noControls": "Dim rheolaethau",
            "failedToSendCommand": "Methwyd ag anfon y gorchymyn"
          }
        },
        "NudgeControl": {
          "nudge": "Nudge",
          "messages": {
            "noControls": "Dim rheolaethau",
            "failedToSendCommand": "Wedi methu ag anfon gorchymyn"
          }
        },
        "DoorControl": {
          "opened": "Agorwyd",
          "locked": "Wedi'i gloi"
        }
      },
      "CallingInfo": {
        "labels": {
          "alarmSessionId": "ID Sesiwn Larwm:",
          "association": "Cysylltiad:"
        },
        "tags": {
          "inbound": "I mewn",
          "outbound": "Allan"
        }
      },
      "messages": {
        "callingError": "Gwall galw, ceisiwch eto os gwelwch yn dda",
        "cannotCallOutWhileRinging": "Methu galw allan tra bod galwad arall yn canu neu'n paratoi",
        "sipNotRegistered": "Cysylltiad SIP ddim yn barod. Arhoswch neu gwiriwch eich gosodiadau."
      },
      "endCause": {
        "ended": "Galwad wedi dod i ben",
        "noAnswer": "Dim Ateb",
        "cancelled": "Wedi'i Ganslo",
        "rejected": "Wedi'i Wrthod",
        "failed": "Wedi Methu"
      },
      "Recording": {
        "failedToResume": "Methwyd ag ailddechrau recordio",
        "failedToStop": "Methwyd â stopio recordio"
      }
    },
    "statistics": {
      "personal": "Personol",
      "team": "Tîm",
      "timeRange": {
        "realTime": "amser real",
        "day": "diwrnod",
        "month": "mis"
      },
      "dataOverview": "Trosolwg Data",
      "workPerformance": "Perfformiad gwaith",
      "todayTotalDuration": "Cyfanswm hyd heddiw",
      "atWork": "Yn y gwaith",
      "onBreak": "Ar egwyl",
      "avgHandleTime": "Amser trin galwadau cyfartalog",
      "avgResponseTime": "Amser ymateb galwadau cyfartalog",
      "totalCalls": "Cyfanswm Galwadau",
      "inbound": "I mewn",
      "outbound": "Allan",
      "inboundCallStatistics": "Ystadegau Galwadau I Mewn",
      "handledCount": "Wedi'i drin: {{count}}",
      "rejectedCount": "Gwrthodwyd: {{count}}",
      "overtimeCount": "Goramser: {{count}}",
      "teamStatus": {
        "title": "Statws Gweithredwr - Cyfanswm: {{total}}",
        "available": "Ar gael",
        "incall": "Yn galw",
        "acw": "Gwaith Ar Ôl Galwad",
        "admin": "Gweinyddol",
        "offline": "All-lein"
      }
    },
    "admin": {
      "CallLogEdit": {
        "failedToSave": "Wedi methu cadw, rhowch gynnig arall arni yn nes ymlaen.",
        "successfullySaved": "Cadwyd yn llwyddiannus.",
        "save": "Cadw"
      }
    },
    "widgets": {
      "arcHeader": {
        "menu": {
          "callLogs": "Logiau Galwadau",
          "statistics": "Ystadegau",
          "callOut": "Galwad allan",
          "dialCard": "Cerdyn Deialu"
        },
        "OperatorInfo": {
          "status": {
            "offline": "All-lein",
            "available": "Ar gael",
            "admin": "Gweinyddwr"
          },
          "online": "Ar-lein:"
        }
      },
      "AdminStatisticsNav": {
        "callLogs": "Logiau Galwadau",
        "statistics": "Ystadegau"
      },
      "TempNoteEdit": {
        "title": {
          "edit": "Golygu Nodyn Dros Dro",
          "create": "Creu Nodyn Dros Dro"
        },
        "field": {
          "timeRange": "Ystod Amser",
          "reason": "Rheswm",
          "note": "Nodyn",
          "alarmType": "Math o Larwm",
          "association": "Cysylltiad",
          "associateTo": "Cysylltu â"
        },
        "placeholder": {
          "startTime": "Amser cychwyn",
          "endTime": "Amser gorffen",
          "note": "Mewnbynnwch nodyn os gwelwch yn dda"
        },
        "validation": {
          "selectTimeRange": "Dewiswch ystod amser os gwelwch yn dda",
          "selectReason": "Dewiswch reswm os gwelwch yn dda",
          "inputNote": "Mewnbynnwch nodyn os gwelwch yn dda"
        },
        "spelling": "Sillafu ({{count}})",
        "replace": "Amnewid"
      },
      "NotificationCallEdit": {
        "title": {
          "edit": "Golygu Galwad Hysbysu",
          "create": "Creu Galwad Hysbysu"
        },
        "field": {
          "selectPeriod": "Dewiswch Gyfnod",
          "reason": "Rheswm",
          "note": "Nodyn",
          "association": "Cysylltiad",
          "timeRange": "Ystod Amser",
          "associateTo": "Cysylltu â"
        },
        "validation": {
          "selectPeriod": "Dewiswch fath o hysbysiad os gwelwch yn dda",
          "selectReason": "Dewiswch reswm os gwelwch yn dda",
          "inputNote": "Mewnbynnwch nodyn os gwelwch yn dda",
          "selectTimeRange": "Dewiswch ystod amser os gwelwch yn dda"
        }
      },
      "SearchModal": {
        "title": "Chwilio ARC",
        "placeholder": {
          "search": "Chwilio",
          "searchEverything": "Chwilio Popeth"
        },
        "noResults": "Ni chafwyd unrhyw ganlyniadau.",
        "searchFailed": "Methodd y chwiliad. Ceisiwch eto os gwelwch yn dda.",
        "columns": {
          "name": "Enw",
          "info": "Gwybodaeth",
          "address": "Cyfeiriad"
        },
        "phoneNumbers": "Rhifau Ffôn",
        "scopes": {
          "all": "Pawb",
          "serviceUser": "Defnyddiwr Gwasanaeth",
          "scheme": "Cynllun",
          "authority": "Awdurdod",
          "contact": "Cyswllt"
        }
      },
      "offline": {
        "OfflinePage": {
          "currentlyOffline": "Ar hyn o bryd all-lein",
          "available": "Ar gael",
          "admin": "Gweinyddol",
          "logout": "Allgofnodi",
          "messages": {
            "failedToUpdate": "Wedi methu diweddaru statws"
          }
        }
      },
      "available": {
        "AvailablePage": {
          "operatorsAhead": "Gweithredwyr ar gael o'ch blaen:"
        }
      },
      "viser": {
        "notification": {
          "supervisor": "Hysbysiad Dywedwch wrth yr archwiliwr am rywbeth sy'n werth ei nodi"
        },
        "waitingCalls": {
          "messages": {
            "accepted": "Rydych chi wedi derbyn y galwad yn llwyddiannus.",
            "acceptedHandleElsewhere": "Rydych chi wedi derbyn y galwad yn llwyddiannus. Triniwch ef yn y dudalen Galw."
          }
        }
      },
      "components": {
        "listItems": {
          "SubscriptionItem": {
            "validUntil": "Yn ddilys tan: {{date}}"
          }
        }
      }
    },
    "callLogs": {
      "DateRangeInput": {
        "last7Days": "7 Diwrnod Diwethaf",
        "last30Days": "30 Diwrnod Diwethaf",
        "last90Days": "90 Diwrnod Diwethaf",
        "last6Months": "6 Mis Diwethaf",
        "startDate": "Dyddiad cychwyn",
        "endDate": "Dyddiad gorffen"
      },
      "CallLogsSearch": {
        "dateTimeRange": "Ystod dyddiad/amser",
        "callerRecipient": "Galwr/Derbynnydd",
        "associateTo": "Cysylltu â",
        "callType": "Math o alwad",
        "searchType": "Math o chwilio",
        "operator": "Gweithredwr",
        "search": "Chwilio",
        "apply": "Gwneud cais",
        "reset": "Ailosod",
        "options": {
          "reason": "Rheswm",
          "outcome": "Canlyniad",
          "note": "Nodyn",
          "serviceUser": "Defnyddiwr Gwasanaeth",
          "contact": "Cyswllt",
          "connection": "Cysylltiad",
          "other": "Arall",
          "scheme": "Cynllun",
          "authority": "Awdurdod",
          "inbound": "I mewn",
          "outbound": "Allan",
          "me": "Fi",
          "others": "Eraill"
        }
      },
      "callLogsColumns": {
        "dateTime": "Dyddiad ac Amser",
        "callerRecipient": "Galwr/Derbynnydd",
        "associateTo": "Cysylltu â",
        "callType": "Math o alwad",
        "reason": "Rheswm",
        "outcome": "Canlyniad",
        "operator": "Gweithredwr",
        "missed": "Wedi methu",
        "rejected": "Gwrthodwyd",
        "waiting": "Yn aros",
        "pending": "Yn yr arfaeth",
        "inProgress": "Ar y gweill",
        "ended": "Wedi dod i ben",
        "completed": "Wedi'i gwblhau"
      }
    }
  },
  "operatorStatus": {
    "update": {
      "failed": "Wedi methu diweddaru statws"
    },
    "offlineReason": "Rheswm All-lein",
    "field": {
      "reason": "Rheswm",
      "description": "Disgrifiad"
    },
    "validation": {
      "selectReason": "Dewiswch reswm"
    }
  },
  "audit": {
    "dateTime": "Dyddiad Amser",
    "operationType": "Math o Weithrediad",
    "field": "Maes",
    "modifier": "Golygydd",
    "modifiedFields": "Meysydd a Wnaethant eu Haddasu",
    "oldValue": "Hen Werth",
    "newValue": "Gwerth Newydd",
    "search": "Chwilio"
  }
}
